import { Box, Divider } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Reset } from '@factorialco/f0-react/icons/app'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { ViewSelector } from 'modules/shift_management/components/ShiftManagement/Content/TableHeader/CommandsFilterBar/ViewSelector/index'
import { ViewOptionsAction } from 'modules/shift_management/hooks/reducers/viewOptions'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useViewOptions } from 'modules/shift_management/hooks/useViewOptions'
import ViewOptions, {
  EmployeeOptions,
  ScheduleOptions,
} from 'modules/shift_management/store/internal/models/ViewOptions'

import EmployeeOptionsContent from './EmployeeOptionsContent'
import ScheduleOptionsContent from './ScheduleOptionsContent'

interface Props {
  viewSelectorDisabled?: boolean
}

const Content = observer(({ viewSelectorDisabled = false }: Props) => {
  const [{ view }] = useSchedule()
  const [{ allViewOptions }, dispatch] = useViewOptions()
  const localStorageKey = LOCAL_STORAGE_KEYS.shiftManagementAllViewOptions
  const [, setAllViewOptions] = useLocalStorage<ViewOptions[]>(localStorageKey)

  const performAction = async (action: ViewOptionsAction) => {
    // Keep this await to ensure the state is updated before saving to local storage
    await dispatch(action)
    setAllViewOptions(allViewOptions.allViewOptions)
  }

  const performEmployeeAction = (option: keyof EmployeeOptions) => {
    performAction({ type: 'TOGGLE_EMPLOYEE_OPTION', view, option })
  }

  const performScheduleAction = (option: keyof ScheduleOptions) => {
    performAction({ type: 'TOGGLE_SCHEDULE_OPTION', view, option })
  }

  const performResetAction = () => {
    performAction({ type: 'RESET_ALL_OPTIONS', view })
  }

  return (
    <Box flexDirection="column" gap="s4" width="full">
      <ViewSelector disabled={viewSelectorDisabled} />
      <Divider />

      <EmployeeOptionsContent onChange={performEmployeeAction} />

      <ScheduleOptionsContent onChange={performScheduleAction} />
      <Divider backgroundColor="background-secondary" />
      <Box
        onClick={performResetAction}
        flexDirection="row"
        gap="s8"
        paddingBottom="s12"
        paddingRight="s12"
        paddingTop="s8"
      >
        <F0Button
          onClick={performResetAction}
          variant="ghost"
          size="md"
          icon={Reset}
          label={i18n.t('shift_management.view_options.reset_filters')}
        />
      </Box>
    </Box>
  )
})

export default Content
